import { useEffect, useState } from 'react';
import { usePlayer, formatTime } from '../../player/PlayerContext';

export default function SeekBar({ compact = false }) {
  const { currentTime, duration, seek, isScrubbing, setIsScrubbing } = usePlayer();
  const [drag, setDrag] = useState(null);

  useEffect(() => {
    if (!isScrubbing) setDrag(null);
  }, [isScrubbing]);

  const value = drag != null ? drag : currentTime;
  const max = Math.max(duration || 0, 0.0001);
  const pct = Math.max(0, Math.min(100, (value / max) * 100));

  const handleInput = (e) => {
    setDrag(parseFloat(e.target.value));
  };

  const beginScrub = () => setIsScrubbing(true);
  const endScrub = (e) => {
    if (drag != null) seek(drag);
    setIsScrubbing(false);
    setDrag(null);
  };

  return (
    <div className={compact ? 'nps-progress' : 'player-progress'}>
      {compact ? (
        <>
          <input
            className="range"
            type="range"
            min={0}
            max={max}
            step={0.05}
            value={value}
            onChange={handleInput}
            onMouseDown={beginScrub}
            onTouchStart={beginScrub}
            onMouseUp={endScrub}
            onTouchEnd={endScrub}
            aria-label="Seek"
            style={{ '--range-pct': `${pct}%` }}
          />
          <div className="nps-time-row">
            <span className="time-label" style={{ textAlign: 'left', minWidth: 0 }}>{formatTime(value)}</span>
            <span className="time-label" style={{ textAlign: 'right', minWidth: 0 }}>{formatTime(duration)}</span>
          </div>
        </>
      ) : (
        <>
          <span className="time-label">{formatTime(value)}</span>
          <input
            className="range"
            type="range"
            min={0}
            max={max}
            step={0.05}
            value={value}
            onChange={handleInput}
            onMouseDown={beginScrub}
            onTouchStart={beginScrub}
            onMouseUp={endScrub}
            onTouchEnd={endScrub}
            aria-label="Seek"
            style={{ '--range-pct': `${pct}%` }}
          />
          <span className="time-label">{formatTime(duration)}</span>
        </>
      )}
    </div>
  );
}
